// CANONICAL COPY (GH #7115). src/constants/obligations/obl-dpa-breach-assistance.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-dpa-breach-assistance',
  title: "Verify procedures to assist controller's supervisory-authority breach notification",
  description:
    'Confirm that the processor has procedures to assist each controller with its supervisory-authority breach notification duties (GDPR Art. 28(3)(f), Art. 33(3); FSR ISAE 3000 Kontrolmål I.4). Distinct from `obl-controller-breach-notification` — this obligation focuses on the subsequent assistance: providing the controller with the nature of the breach, likely consequences, measures taken or proposed and any supporting forensic evidence needed for the Datatilsynet / supervisory-authority notification. Procedures shall define the evidence package, response-time commitments, and records of assistance provided per controller breach.',
  category: 'incidents',
  scfIds: ['SCF-INC-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'DPA breach-assistance procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
